var AutosizeInput = {};

export { AutosizeInput as __exports };
